import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles({
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    color: colors.gray45,
  },
  text: {
    color: colors.black,
    display: 'contents',
  },
  icon: {
    color: colors.gray15,
    '& svg': {
      height: '16px',
    },
  },
  totalCount: {
    color: colors.gray10,
    '& span': {
      marginBottom: '-2px',
      paddingTop: '-2px',
    },
  },
  showMoreOrLess: {
    display: 'inline-flex',
    color: 'inherit',
    fontWeight: 600,
    fontSize: '14px',
    letterSpacing: '0.25px',
    borderBottom: `1px solid ${colors.gray45}`,
    marginLeft: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
    '& span': {
      marginBottom: '-2px',
    },
  },
  showMoreOrLessIcon: {
    position: 'relative',
    left: '1px',
    top: '4px',
    width: '18px',
    height: '18px',
    marginLeft: '-2px',
    marginRight: '4px',
    color: colors.gray45,
  },
});
